import { render, staticRenderFns } from "./login.vue?vue&type=template&id=40f4ffbb&scoped=true"
import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=40f4ffbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f4ffbb",
  null
  
)

export default component.exports